export default __webpack_public_path__ + "static/media/login_icon.5ab128e1.png";